import { Grid, Typography } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import AppCard from "../../components/cards/AppCard";
import { geProposalOverview } from "../../api/platform/platform.proposals";
import { IProposalOverview } from "../../common/interfaces/proposal.interface";
import { Pie } from "react-chartjs-2";
import {
  generateProposalStatusPieData,
  generateProposalTypePieData,
  getProposalMaxVotingTime,
  round,
} from "../../utils/helpers";

const PlatformProposals: FC = () => {
  const [proposalOverview, setProposalOverview] = useState<IProposalOverview>();
  const [cardLoader, setCardLoader] = useState<boolean>(false);

  useEffect(() => {
    void geProposalOverviewFromApi();
  }, []);

  const geProposalOverviewFromApi = async () => {
    try {
      setCardLoader(true);
      console.log(await geProposalOverview());
      setProposalOverview(await geProposalOverview());
      setCardLoader(false);
    } catch (error) {
      console.log(error);
    }
  };

  const totalNumberOfProposals = useMemo(() => {
    return proposalOverview && proposalOverview.total;
  }, [proposalOverview]);

  const avarageProposals = useMemo(() => {
    return proposalOverview ? proposalOverview.avarageProposals : 0;
  }, [proposalOverview]);

  const avarageApprovalQuorum = useMemo(() => {
    return proposalOverview && proposalOverview.avarageApprovalQuorum;
  }, [proposalOverview]);

  const avarageVotingTime = useMemo(() => {
    return proposalOverview && proposalOverview.avarageVotingTime;
  }, [proposalOverview]);

  return (
    <div>
      <Grid
        container
        spacing={{ xs: 1, md: 2, sm: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Typography
          variant="h4"
          component="span"
          key={`typography1`}
          sx={{
            display: "flex",
            alignItems: "center",
            padding: 1,
            width: "100%",
          }}
        >
          Proposals
        </Typography>
        <Grid item xs={12} sm={12} md={4}>
          <AppCard
            label={"Total number of proposals"}
            value={`${totalNumberOfProposals}`}
            loader={cardLoader}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <AppCard
            label={"Average number of proposals by club"}
            value={`${round(avarageProposals)}`}
            loader={cardLoader}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <AppCard
            label={"Average “Max voting time”"}
            value={`${
              avarageVotingTime && getProposalMaxVotingTime(avarageVotingTime)
            }`}
            loader={cardLoader}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={5.5}>
        <Grid
          container
          spacing={{ xs: 2, md: 3, sm: 4 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
          paddingTop={2}
          justifyContent="space-evenly"
          alignItems="start"
        >
          <Grid item xs={12} sm={12} md={4}>
            <Typography
              variant="body1"
              component="span"
              key={`typography1`}
              sx={{
                display: "flex",
                alignItems: "center",
                padding: 1,
                width: "100%",
              }}
            >
              Proposal status
            </Typography>
            {proposalOverview && (
              <Pie data={generateProposalStatusPieData(proposalOverview)} />
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Typography
              variant="body1"
              component="span"
              key={`typography1`}
              sx={{
                display: "flex",
                alignItems: "center",
                padding: 1,
                width: "100%",
              }}
            >
              Proposal type
            </Typography>
            {proposalOverview && (
              <Pie data={generateProposalTypePieData(proposalOverview)} />
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default PlatformProposals;
